const isVariationSelected = (variations, attributes) => {
  if (!variations) return true;
  if (attributes) {
    // return Object.keys(variations).every((variation) => attributes.hasOwnProperty(variation));
  }
  return false;
};

export default isVariationSelected;
